export default __webpack_public_path__ + "static/media/deepn.e7b8a319.png";